import { render, staticRenderFns } from "./AdminBrandInventory.vue?vue&type=template&id=25f1b189"
import script from "./AdminBrandInventory.vue?vue&type=script&lang=js"
export * from "./AdminBrandInventory.vue?vue&type=script&lang=js"
import style0 from "./AdminBrandInventory.vue?vue&type=style&index=0&id=25f1b189&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports